import React from "react"
import { Select } from "antd"
import { SB_CAMPAIGNS_STATE_FILTER } from "../types/sbCampaignApi.types"

interface ISbStateFilter {
  value: SB_CAMPAIGNS_STATE_FILTER
  onChange: (value: SB_CAMPAIGNS_STATE_FILTER) => void
}

const STATE_FILTER_OPTIONS = [
  { value: SB_CAMPAIGNS_STATE_FILTER.ALL, label: "All" },
  { value: SB_CAMPAIGNS_STATE_FILTER.ENABLED, label: "Active" },
  { value: SB_CAMPAIGNS_STATE_FILTER.PAUSED, label: "Paused" },
]

const SbStateFilter: React.FC<ISbStateFilter> = ({ value, onChange }) => (
  <Select
    aria-label="Campaign state"
    value={value}
    onChange={onChange}
    options={STATE_FILTER_OPTIONS}
    style={{ width: 110 }}
  />
)

export default SbStateFilter
